import script from "./UserLogout.vue?vue&type=script&setup=true&lang=js"
export * from "./UserLogout.vue?vue&type=script&setup=true&lang=js"

import "./UserLogout.vue?vue&type=style&index=0&id=79b6a1a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79b6a1a6"]])

export default __exports__